import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface ProtectedRouteProps {
    children: React.ReactNode;
    requiredPage?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredPage }) => {
    const location = useLocation();
    const token = localStorage.getItem('adminToken');
    const userStr = localStorage.getItem('adminUser');
    const user = userStr ? JSON.parse(userStr) : null;

    if (!token || !user) {
        return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }

    // Check for token expiry
    try {
        const parts = token.split('.');
        if (parts.length === 3) {
            const payload = JSON.parse(atob(parts[1] as string));
            const exp = payload.exp * 1000;
            if (Date.now() >= exp) {
                localStorage.removeItem('adminToken');
                localStorage.removeItem('adminUser');
                return <Navigate to="/admin/login" state={{ from: location }} replace />;
            }
        }
    } catch (e) {
        // Invalid token
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminUser');
        return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }

    if (requiredPage && !user.is_root) {
        const hasPermission = user.permissions?.some((p: any) => p.page_name === requiredPage);
        if (!hasPermission) {
            return <Navigate to="/admin/dashboard" replace />;
        }
    }

    return <>{children}</>;
};

export default ProtectedRoute;
